<button
    type="button"
    role="switch"
    [id]="inputId() + '-button'"
    [attr.aria-labelledby]="inputId() + '-label'"
    [attr.aria-checked]="checked()"
    class="vds-switch__track"
    [class.vds-switch__track--md]="size() === 'medium'"
    [class.vds-switch__track--lg]="size() === 'large'"
    [disabled]="disabled()"
    (click)="toggle()"
>
    <div
        class="vds-switch__handle"
        [class.vds-switch__handle--md]="size() === 'medium'"
        [class.vds-switch__handle--lg]="size() === 'large'"
    >
        <vds-icon name="checkmark" aria-hidden="true" />
    </div>
</button>

<label [for]="inputId() + '-button'" [id]="inputId() + '-label'" class="vds-switch__label">
    <ng-content />
</label>
